import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

class Description extends React.Component {
  render() {
    return (
      <div className="description">
          <ReactCSSTransitionGroup
            transitionName="description"
            transitionAppear={true}
            transitionAppearTimeout={800}
            transitionEnterTimeout={800}
            transitionLeave={false}>
            <span key={this.props.id}>
              {React.cloneElement(this.props.children, ...this.props)}
            </span>
          </ReactCSSTransitionGroup>
      </div>
    )
  }
}

export default Description;



// WEBPACK FOOTER //
// ./src/components/Description.js